import { useEffect, useState } from "react";
import api from "../api/api";

export interface NavigationSettings {
    forumRtqCategoryId: string | null;
    forumPlayerStoryCategoryId: string | null;
    forumPlayerArtCategoryId: string | null;
}

const useNavigationSettings = (): NavigationSettings => {
    const [settings, setSettings] = useState<NavigationSettings>({
        forumRtqCategoryId: null,
        forumPlayerStoryCategoryId: null,
        forumPlayerArtCategoryId: null,
    });

    useEffect(() => {
        api.get("settings/navigation")
            .then((response) => {
                setSettings(response.data);
            })
            .catch(() => {
                // Navigation links will be hidden if settings are unavailable
            });
    }, []);

    return settings;
};

export default useNavigationSettings;
